@if (showToolbar) {
  <div class="angular-editor-toolbar">
    <div class="angular-editor-toolbar-set">
      <button type="button" title="Annuler" class="angular-editor-button" (click)="triggerCommand('undo')"
        [hidden]="isButtonHidden('undo')" tabindex="-1">
        <fa-icon icon="undo"></fa-icon>
      </button>
      <button type="button" title="Répéter" class="angular-editor-button" (click)="triggerCommand('redo')"
        [hidden]="isButtonHidden('redo')" tabindex="-1">
        <fa-icon icon="repeat"
        ></fa-icon>
      </button>
    </div>
    <div class="angular-editor-toolbar-set">
      <button [id]="'bold-'+id" type="button" title="Gras" class="angular-editor-button" (click)="triggerCommand('bold')"
        [disabled]="htmlMode" [hidden]="isButtonHidden('bold')" tabindex="-1">
        <fa-icon icon="bold"></fa-icon>
      </button>
      <button [id]="'italic-'+id" type="button" title="Italique" class="angular-editor-button"
        (click)="triggerCommand('italic')"
        [disabled]="htmlMode" [hidden]="isButtonHidden('italic')" tabindex="-1">
        <fa-icon icon="italic"></fa-icon>
      </button>
      <button [id]="'underline-'+id" type="button" title="Soulignage" class="angular-editor-button"
        (click)="triggerCommand('underline')" [disabled]="htmlMode" [hidden]="isButtonHidden('underline')"
        tabindex="-1">
        <fa-icon icon="underline"></fa-icon>
      </button>
      <button [id]="'strikeThrough-'+id" type="button" title="Barré" class="angular-editor-button"
        (click)="triggerCommand('strikeThrough')" [disabled]="htmlMode" [hidden]="isButtonHidden('strikeThrough')"
        tabindex="-1">
        <fa-icon icon="strikethrough"></fa-icon>
      </button>
      <button [id]="'superscript-'+id" type="button" title="Exposant" class="angular-editor-button"
        (click)="triggerCommand('superscript')" [disabled]="htmlMode" [hidden]="isButtonHidden('superscript')"
        tabindex="-1">
        <fa-icon icon="superscript"></fa-icon>
      </button>
      <button [id]="'subscript-'+id" type="button" title="Indice" class="angular-editor-button"
        (click)="triggerCommand('subscript')" [disabled]="htmlMode" [hidden]="isButtonHidden('subscript')"
        tabindex="-1">
        <fa-icon icon="subscript"></fa-icon>
      </button>
    </div>
    <div class="angular-editor-toolbar-set">
      <button [id]="'justifyLeft-'+id" type="button" title="Aligner à gauche" class="angular-editor-button"
        (click)="triggerCommand('justifyLeft')" [disabled]="htmlMode" [hidden]="isButtonHidden('justifyLeft')"
        tabindex="-1">
        <fa-icon icon="align-left"></fa-icon>
      </button>
      <button [id]="'justifyCenter-'+id" type="button" title="Centrer" class="angular-editor-button"
        (click)="triggerCommand('justifyCenter')" [disabled]="htmlMode" [hidden]="isButtonHidden('justifyCenter')"
        tabindex="-1">
        <fa-icon icon="align-center"></fa-icon>
      </button>
      <button [id]="'justifyRight-'+id" type="button" title="Aligner à droite" class="angular-editor-button"
        (click)="triggerCommand('justifyRight')" [disabled]="htmlMode" [hidden]="isButtonHidden('justifyRight')"
        tabindex="-1">
        <fa-icon icon="align-right"></fa-icon>
      </button>
      <button [id]="'justifyFull-'+id" type="button" title="Justifié" class="angular-editor-button"
        (click)="triggerCommand('justifyFull')" [disabled]="htmlMode" [hidden]="isButtonHidden('justifyFull')"
        tabindex="-1">
        <fa-icon icon="align-justify"></fa-icon>
      </button>
    </div>
    <div class="angular-editor-toolbar-set">
      <button [id]="'indent-'+id" type="button" title="Augmenter le retrait" class="angular-editor-button"
        (click)="triggerCommand('indent')"
        [disabled]="htmlMode" [hidden]="isButtonHidden('indent')" tabindex="-1">
        <fa-icon icon="indent"></fa-icon>
      </button>
      <button [id]="'outdent-'+id" type="button" title="Diminuer le retrait" class="angular-editor-button"
        (click)="triggerCommand('outdent')"
        [disabled]="htmlMode" [hidden]="isButtonHidden('outdent')" tabindex="-1">
        <fa-icon icon="outdent"></fa-icon>
      </button>
    </div>
    <div class="angular-editor-toolbar-set">
      <button [id]="'insertUnorderedList-'+id" type="button" title="Liste non ordonnée" class="angular-editor-button"
        (click)="triggerCommand('insertUnorderedList')" [disabled]="htmlMode"
        [hidden]="isButtonHidden('insertUnorderedList')" tabindex="-1">
        <fa-icon icon="list-ul"></fa-icon>
      </button>
      <button [id]="'insertOrderedList-'+id" type="button" title="Liste ordonnée" class="angular-editor-button"
        (click)="triggerCommand('insertOrderedList')" [disabled]="htmlMode"
        [hidden]="isButtonHidden('insertOrderedList')" tabindex="-1">
        <fa-icon icon="list-ol"></fa-icon>
      </button>
    </div>
    <div class="angular-editor-toolbar-set">
      <app-ae-select class="select-heading" [options]="headings"
        [(ngModel)]="block"
        (change)="triggerCommand(block)"
        [disabled]="htmlMode"
        [hidden]="isButtonHidden('heading')"
      tabindex="-1"></app-ae-select>
    </div>
    <div class="angular-editor-toolbar-set">
      <app-ae-select class="select-font" [options]="fonts"
        [(ngModel)]="fontName"
        (change)="setFontName(fontName)"
        [disabled]="htmlMode"
        [hidden]="isButtonHidden('fontName')"
      tabindex="-1"></app-ae-select>
    </div>
    <div class="angular-editor-toolbar-set">
      <app-ae-select class="select-font-size" [options]="fontSizes"
        [(ngModel)]="fontSize"
        (change)="setFontSize(fontSize)"
        [disabled]="htmlMode"
        [hidden]="isButtonHidden('fontSize')"
        tabindex="-1">
      </app-ae-select>
    </div>
    <div class="angular-editor-toolbar-set">
      <input
        style="display: none"
        type="color" (change)="insertColor(fgInput.value, 'textColor')"
        #fgInput>
      <button [id]="'foregroundColorPicker-'+id" type="button" class="angular-editor-button"
        (click)="focus(); ; fgInput.click()"
        title="Couleur de texte"
        [disabled]="htmlMode" [hidden]="isButtonHidden('textColor')" tabindex="-1"><span
        class="color-label foreground"><fa-icon icon="font"></fa-icon></span>
      </button>
      <input
        style="display: none"
        type="color" (change)="insertColor(bgInput.value, 'backgroundColor')"
        #bgInput>
      <button [id]="'backgroundColorPicker-'+id" type="button" class="angular-editor-button"
        (click)="focus(); ; bgInput.click()"
        title="Couleur de surlignage"
        [disabled]="htmlMode" [hidden]="isButtonHidden('backgroundColor')" tabindex="-1"><span
        class="color-label background"><fa-icon icon="font"></fa-icon></span>
      </button>
    </div>
    @if (_customClasses) {
      <div class="angular-editor-toolbar-set">
        <app-ae-select class="select-custom-style" [options]="customClassList"
          [(ngModel)]="customClassId"
          (change)="setCustomClass(customClassId)"
          [disabled]="htmlMode"
          [hidden]="isButtonHidden('customClasses')"
        tabindex="-1"></app-ae-select>
      </div>
    }
    <div class="angular-editor-toolbar-set">
      <button [id]="'link-'+id" type="button" class="angular-editor-button" (click)="insertUrl()"
        title="Insérer un lien" [disabled]="isLinkButtonDisabled" [hidden]="isButtonHidden('link')" tabindex="-1">
        <fa-icon icon="link"></fa-icon>
      </button>
      <button [id]="'unlink-'+id" type="button" class="angular-editor-button" (click)="triggerCommand('unlink')"
        title="Supprimer le lien" [disabled]="htmlMode || !linkSelected" [hidden]="isButtonHidden('unlink')" tabindex="-1">
        <fa-icon icon="unlink"></fa-icon>
      </button>
      <input
        style="display: none"
        accept="image/*"
        type="file" (change)="onFileChanged($event)"
        #fileInput>
      <button [id]="'insertImage-'+id" type="button" class="angular-editor-button" (click)="focus(); fileInput.click()"
        title="Insérer une image"
        [disabled]="htmlMode" [hidden]="isButtonHidden('insertImage')" tabindex="-1">
        <fa-icon icon="image"></fa-icon>
      </button>
      <button [id]="'insertVideo-'+id" type="button" class="angular-editor-button"
        (click)="insertVideo()" title="Insérer une vidéo" [disabled]="htmlMode" [hidden]="isButtonHidden('insertVideo')"
        tabindex="-1">
        <fa-icon icon="video"></fa-icon>
      </button>
      <button [id]="'insertHorizontalRule-'+id" type="button" title="Ligne horizontale" class="angular-editor-button"
        (click)="triggerCommand('insertHorizontalRule')" [disabled]="htmlMode"
        [hidden]="isButtonHidden('insertHorizontalRule')" tabindex="-1">
        <fa-icon icon="minus"></fa-icon>
      </button>
    </div>
    <div class="angular-editor-toolbar-set">
      <button [id]="'clearFormatting-'+id" type="button" title="Effacer le formatage" class="angular-editor-button"
        (click)="triggerCommand('removeFormat')" [disabled]="htmlMode" [hidden]="isButtonHidden('removeFormat')"
        tabindex="-1">
        <fa-icon icon="remove-format"></fa-icon>
      </button>
    </div>
    <div class="angular-editor-toolbar-set">
      <button [id]="'toggleEditorMode-'+id" type="button" title="Code HTML" class="angular-editor-button"
        (click)="triggerCommand('toggleEditorMode')" [hidden]="isButtonHidden('toggleEditorMode')" tabindex="-1">
        <fa-icon icon="code"></fa-icon>
      </button>
    </div>
    <ng-content></ng-content>
  </div>
}
